import { styled } from 'styled-components';

import { createResponsiveSpacingStyle, getColor } from '../../utils';
import type { Colors, ResponsiveSpacing } from '../../utils/types';

export const StyledTriangle = styled.div<TriangleProps>`
  position: absolute;
  top: -0.625rem;
  ${props => props.right && createResponsiveSpacingStyle('right', props.right)};
  ${props => props.left && createResponsiveSpacingStyle('left', props.left)};
  width: 0;
  height: 0;
  border-bottom: 0.688rem solid ${props => getColor(props.color || 'white')};
  border-left: 0.563rem solid transparent;
  border-right: 0.563rem solid transparent;
  ${props => props.width && createResponsiveSpacingStyle('border-left-width', props.width)};
  ${props => props.width && createResponsiveSpacingStyle('border-right-width', props.width)};
`;

type TriangleProps = {
  /** Moves the arrow to the right, depending on how big the value is. */
  right?: ResponsiveSpacing;
  /** Moves the arrow to the left, depending on how big the value is. */
  left?: ResponsiveSpacing;
  /** Color for the `<Triangle/>`, if the color is missing, add it. */
  color?: Colors;
  width?: ResponsiveSpacing;
};

export const Triangle = ({ right = 'none', left = 'none', color = 'white', width = 9 }: TriangleProps) => {
  return <StyledTriangle right={right} left={left} color={color} width={width} />;
};
